<div class="bg-white rounded-2xl shadow-2xl overflow-hidden w-full max-w-md flex flex-col max-h-[90vh]">
  <!-- Header -->
  <div class="px-6 py-4 border-b border-gray-100 flex items-center justify-between shrink-0">
    <div class="flex items-center gap-3 min-w-0">
      <div class="w-10 h-10 rounded-xl bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center shrink-0 shadow-sm">
        <svg class="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
        </svg>
      </div>
      <div class="min-w-0">
        <h2 class="text-lg font-bold text-gray-900 leading-tight">Manage tenants</h2>
        <p class="text-xs text-gray-400 truncate">{{ employee.firstName }} {{ employee.name }}</p>
      </div>
    </div>
    <button (click)="closeModal()" class="p-1.5 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition-colors cursor-pointer">
      <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" /></svg>
    </button>
  </div>

  <!-- Content -->
  <div class="px-6 py-5 overflow-y-auto flex-1 min-h-0 bg-gray-50/40 custom-scrollbar">
    @if(loading) {
    <div class="flex justify-center items-center py-8">
      <div class="w-6 h-6 rounded-full border-3 border-blue-100 border-t-blue-600 animate-spin"></div>
    </div>
    } @else {
    <p class="text-sm text-gray-500 mb-3">Select the tenants this employee should have access to:</p>

    @if(allTenants.length === 0) {
    <div class="text-center py-8 bg-white rounded-xl border border-dashed border-gray-200">
      <svg class="w-10 h-10 text-gray-300 mx-auto mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" /></svg>
      <p class="text-sm text-gray-500">No tenants available</p>
      <p class="text-xs text-gray-400 mt-1">Create tenants in the admin section first</p>
    </div>
    } @else {
    <div class="space-y-2 max-h-[300px] overflow-y-auto custom-scrollbar">
      @for(tenant of allTenants; track tenant.id) {
      <label class="flex items-center gap-3 p-3 rounded-xl border cursor-pointer transition-all"
        [class.border-blue-300]="isTenantAssigned(tenant.id)"
        [class.bg-blue-50]="isTenantAssigned(tenant.id)"
        [class.border-gray-200]="!isTenantAssigned(tenant.id)"
        [class.bg-white]="!isTenantAssigned(tenant.id)"
        [class.hover:border-gray-300]="!isTenantAssigned(tenant.id)"
        [class.opacity-60]="!tenant.isActive">
        <input type="checkbox" [checked]="isTenantAssigned(tenant.id)" (change)="toggleTenant(tenant.id)"
          class="w-5 h-5 rounded border-gray-300 text-blue-600 focus:ring-blue-500 cursor-pointer">
        <div class="flex-1 min-w-0">
          <div class="font-medium text-sm text-gray-900">{{ tenant.name }}</div>
          @if(!tenant.isActive) { <span class="text-xs text-amber-600">(Inactive)</span> }
        </div>
        @if(isTenantAssigned(tenant.id)) {
        <svg class="w-5 h-5 text-blue-600 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" /></svg>
        }
      </label>
      }
    </div>

    <div class="mt-4 pt-4 border-t border-gray-100">
      <div class="flex items-center justify-between text-sm">
        <span class="text-gray-500">Selected tenants</span>
        <span class="font-semibold text-blue-600">{{ assignedTenantIds.size }}</span>
      </div>
    </div>
    }
    }
  </div>

  <!-- Footer -->
  <div class="px-6 py-3.5 border-t border-gray-100 flex justify-end gap-2 bg-gray-50/50 shrink-0">
    <button (click)="closeModal()" class="px-4 py-2.5 text-gray-700 text-sm font-medium hover:bg-gray-100 rounded-lg transition-colors cursor-pointer">Cancel</button>
    <button (click)="save()" [disabled]="saving || !hasChanges()"
      class="bg-blue-600 text-white text-sm font-semibold py-2.5 px-5 rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors shadow-sm cursor-pointer flex items-center gap-2">
      @if(saving) { <span class="animate-spin h-4 w-4 border-2 border-white border-t-transparent rounded-full"></span> }
      {{ saving ? 'Saving…' : 'Save changes' }}
    </button>
  </div>
</div>
